import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Stack,
} from "@mui/material";
import { useApi } from "../../utils/api";

export default function InstagramFeed({ userId }) {
  const { getInstagramFeed } = useApi();
  const [state, setState] = useState({ loading: true, error: "", items: [] });

  useEffect(() => {
    const load = async () => {
      if (!userId) {
        setState({ loading: false, error: "Missing userId", items: [] });
        return;
      }

      setState((s) => ({ ...s, loading: true, error: "" }));

      try {
        const j = await getInstagramFeed(userId);
        if (j.error)
          throw new Error(j.error || "Failed to load Instagram feed");

        setState({ loading: false, error: "", items: j?.data || [] });
      } catch (e) {
        setState({ loading: false, error: e.message, items: [] });
      }
    };

    load();
  }, [userId, getInstagramFeed]);

  if (state.loading) {
    return (
      <Stack direction="row" spacing={2} alignItems="center">
        <CircularProgress />
        <Typography>Loading Instagram…</Typography>
      </Stack>
    );
  }

  if (state.error) return <Alert severity="error">{state.error}</Alert>;

  if (state.items.length === 0) {
    return null;
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {state.items.map((m) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={m.id}>
            <Card>
              <CardActionArea
                href={m.permalink}
                target="_blank"
                rel="noreferrer"
              >
                <CardMedia
                  component="img"
                  height="180"
                  image={
                    m.media_type === "VIDEO"
                      ? m.thumbnail_url || m.media_url
                      : m.media_url
                  }
                  alt={m.caption || "Instagram post"}
                />
                <CardContent>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {m.caption || " "}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(m.timestamp).toLocaleString()}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
